export const ACTIVITIES_GLOBAL = 'global'
export const ACTIVITIES_MINE = 'mine'

export const ACTIVITIES = {
    GLOBAL: ACTIVITIES_GLOBAL,
    MINE: ACTIVITIES_MINE
}
